export default __webpack_public_path__ + "static/media/add-circle.7c611166.svg";